import CalculatorProcess from './CalculatorProcess'

export default CalculatorProcess
